export const DEFAULT_SPECIALITY_KEY = 'ALL';
